import React from 'react';
import ReactDOM from 'react-dom/client';
import '@delhivery/design-tokens/css';        // Tarmac TDS theme (CSS variables)
import '@delhivery/tarmac/dist/style.css';     // Tarmac component styles
import './index.css';
import App from './App';
// import AppTest from './AppTest'; // Uncomment to test basic rendering
import reportWebVitals from './reportWebVitals';
import { KeycloakProvider } from './components/Auth/KeycloakProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Error boundary for debugging
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', background: '#ffe6e6', color: '#cc0000' }}>
          <h1>⚠️ Error Loading App</h1>
          <pre>{this.state.error?.toString()}</pre>
          <pre>{this.state.error?.stack}</pre>
        </div>
      );
    }
    return this.props.children;
  }
}

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <KeycloakProvider>
        <App />
      </KeycloakProvider>
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
